import { c as _c } from "react/compiler-runtime";
import { IcoPencil16 } from '@onefootprint/icons';
import type { Annotation, AnnotationTimelineEvent } from '@onefootprint/request-types/dashboard';
import { IconButton } from '@onefootprint/ui';
import dynamic from 'next/dynamic';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PermissionGate from '@/components/permission-gate';
import Actor from '../actor';
const FreeFormDialog = dynamic(() => import('../../../free-form-dialog'));
type AnnotationEventHeaderProps = {
  annotationEvent: AnnotationTimelineEvent;
};
const AnnotationEventHeader = t0 => {
  const $ = _c(31);
  const {
    annotationEvent
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const [dialogOpen, setDialogOpen] = useState(false);
  let t2;
  if ($[1] !== annotationEvent.deactivatedAt || $[2] !== annotationEvent.id || $[3] !== annotationEvent.isPinned || $[4] !== annotationEvent.note || $[5] !== annotationEvent.originAnnotationId || $[6] !== annotationEvent.source || $[7] !== annotationEvent.timestamp) {
    t2 = {
      deactivatedAt: annotationEvent.deactivatedAt,
      id: annotationEvent.id,
      isPinned: annotationEvent.isPinned,
      note: annotationEvent.note,
      originAnnotationId: annotationEvent.originAnnotationId,
      source: annotationEvent.source,
      timestamp: annotationEvent.timestamp
    };
    $[1] = annotationEvent.deactivatedAt;
    $[2] = annotationEvent.id;
    $[3] = annotationEvent.isPinned;
    $[4] = annotationEvent.note;
    $[5] = annotationEvent.originAnnotationId;
    $[6] = annotationEvent.source;
    $[7] = annotationEvent.timestamp;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const annotation = t2;
  let t3;
  if ($[9] !== t) {
    t3 = t(_temp);
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <p className="text-body-2 text-tertiary fp-text">{t3}</p>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== annotation.source) {
    t5 = <Actor actor={annotation.source} />;
    $[13] = annotation.source;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="flex flex-wrap items-center gap-1 md:flex-nowrap">{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t) {
    t7 = t(_temp2);
    $[18] = t;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setDialogOpen(true);
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7) {
    t9 = <PermissionGate fallbackText="" scopeKind="manual_review" tooltipSide="bottom"><div className="flex items-center md:opacity-0 group-hover:opacity-100 transition-opacity"><IconButton aria-label={t7} icon={IcoPencil16} size="tiny" onClick={t8} /></div></PermissionGate>;
    $[21] = t7;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setDialogOpen(false);
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== annotation || $[25] !== dialogOpen) {
    t11 = <Suspense fallback={null}><FreeFormDialog open={dialogOpen} onClose={t10} annotation={annotation} /></Suspense>;
    $[24] = annotation;
    $[25] = dialogOpen;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t6 || $[29] !== t9) {
    t12 = <div className="flex items-center gap-2 flex-1">{t6}{t9}{t11}</div>;
    $[27] = t11;
    $[28] = t6;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  return t12;
};
export default AnnotationEventHeader;
function _temp($) {
  return $.timeline.freeFormNoteEvent.noteAddedBy;
}
function _temp2($_0) {
  return $_0.freeFormNote.dialog.title.edit;
}